// extracted by mini-css-extract-plugin
export default {"gantt":"gantt","gantt-wrapper":"gantt-wrapper","no_data":"no_data","loading_wrap":"loading_wrap"};